module.exports = __webpack_public_path__ + "img/product32_img08.88936f67.png";